export const sanMarino = '#5064B2';
export const mako = '#404451';
export const deepDarkMarino = '#0F277E';
export const karimunBlue = '#2196f3';
export const googleBlue = '#1E88E5';
